import React from 'react'

const SvgComponent = props => (
  <svg viewBox='0 0 144.82 233.5' {...props}>
    <defs />
    <g id='Layer_2' data-name='Layer 2'>
      <g id='Layer_1-2' data-name='Layer 1'>
        <path
          className='cls-1'
          d='M56.72 233.5H88.1V0H56.72zm8-54.73l15.38-16.48v34.21L64.72 180zm0-50.11l15.38-16.49v34.21L64.72 129.9zm0-50.11L80.1 62.06v34.22L64.72 79.79zm0-50.11L80.1 11.95v34.21L64.72 29.68zM80.1 53.49v1.24L64.72 71.22V37zm0 50.11v1.24l-15.38 16.49V87.12zm0 50.11V155l-15.38 16.44v-34.21zm0 50.11v1.24l-15.38 16.5v-34.22zM67.87 225.5l12.23-13.1v13.1zM77 8L64.72 21.11V8zM113.44 75.17V233.5h31.39V75.17zm23.39 28.43v1.24l-15.39 16.48v-34.2zm0 51.36l-15.39 16.48v-34.21l15.39 16.48zm0 50.11l-15.39 16.48v-34.21l15.39 16.48zM121.44 180v-1.24l15.39-16.48v34.22zm0-50.11v-1.24l15.39-16.48v34.21zm15.39-33.63l-12.24-13.09h12.23zM124.59 225.5l12.23-13.11v13.11zM0 233.5h31.39V100.22H0zm8-54.73l15.39-16.48v34.21L8 180zm0-50.11l15.39-16.49v34.21L8 129.9zm15.39 25.06V155L8 171.44v-34.21zm0 50.11v1.24L8 221.56v-34.22zM11.15 225.5l12.24-13.1v13.1zm9.08-117.28L8 121.33v-13.11z'
        />
      </g>
    </g>
  </svg>
)

export default SvgComponent



// WEBPACK FOOTER //
// ./src/components/UI/Icons/AmericanaIcon.js